<template>
  <div class="tContent">
    <div class="fRow">
        <table>
        <tr>
          <td rowspan="2" class="sTtile">មុខវិជ្ជា</td>
          <td rowspan="2" class="sTtile">ភេទ</td>
          <td colspan="16" style="text-align:center;background-color: #f8f8f8;font-weight: bold;">
            ពិន្ទុមធ្យម (ប្រឡងឆមាសទី ១ + ប្រឡងឆមាសទី ២) ចែក ២
          </td>
          <td rowspan="2" class="colTotal">សរុប</td>
          <td rowspan="2" style="width:50px;text-align:center;background-color: #f8f8f8;font-weight: bold;">សរុប សិស្សជាប់</td>
        </tr>
        <tr>
          <td class="colHeader">0</td>
          <td class="colHeader">1-10</td>
          <td class="colHeader">11-20</td>
          <td class="colHeader">21-30</td>
          <td class="colHeader">31-40</td>
          <td class="colHeader">41-50</td>
          <td class="colHeader">51-60</td>
          <td class="colHeader">61-70</td>
          <td class="colHeader">71-80</td>
          <td class="colHeader">81-90</td>
          <td class="colHeader">91-100</td>
          <td class="colHeader">101-110</td>
          <td class="colHeader">111-120</td>
          <td class="colHeader">121-130</td>
          <td class="colHeader">131-140</td>
          <td class="colHeader">141-150</td>
        </tr>
      </table> 
    </div>
    <div class="sRow">
      <div>
        <v-container class="cont">
          <table>
            <tr><td rowspan="2" class="sTtile">ភាសាខ្មែរ</td><td class="gender">ស្រី</td></tr>
            <tr><td class="gender">ប្រុស</td></tr>
            <tr><td rowspan="2" class="sTtile">សិលធម៌ - ពលរដ្ឋវិជ្ជា</td><td class="gender">ស្រី</td></tr>
            <tr><td class="gender">ប្រុស</td></tr>
            <tr><td rowspan="2" class="sTtile">ប្រវត្តិវិទ្យា</td><td class="gender">ស្រី</td></tr>
            <tr><td class="gender">ប្រុស</td></tr>
            <tr><td rowspan="2" class="sTtile">ភូមិវិទ្យា</td><td class="gender">ស្រី</td></tr>
            <tr><td class="gender">ប្រុស</td></tr>
            <tr><td rowspan="2" class="sTtile">គណិតវិទ្យា</td><td class="gender">ស្រី</td></tr>
            <tr><td class="gender">ប្រុស</td></tr>
            <tr><td rowspan="2" class="sTtile">រូបវិទ្យា</td><td class="gender">ស្រី</td></tr>
            <tr><td class="gender">ប្រុស</td></tr>
            <tr><td rowspan="2" class="sTtile">គីមីវិទ្យា</td><td class="gender">ស្រី</td></tr>
            <tr><td class="gender">ប្រុស</td></tr>
            <tr><td rowspan="2" class="sTtile">ជីវវិទ្យា</td><td class="gender">ស្រី</td></tr>
            <tr><td class="gender">ប្រុស</td></tr>
            <tr><td rowspan="2" class="sTtile">ផែនដីវិទ្យា</td><td class="gender">ស្រី</td></tr>
            <tr><td class="gender">ប្រុស</td></tr>
            <tr><td rowspan="2" class="sTtile">ភាសាបរទេស</td><td class="gender">ស្រី</td></tr>
            <tr><td class="gender">ប្រុស</td></tr>
          </table>
        </v-container>      
      </div>
      <div>
        <v-container class="contD">
          <v-slide-y-transition mode="out-in">
            <v-layout column align-center>
              <score-by-Subject :dataRow="scoreData[0]" :dataDisable="apCon[0]" :endCol="eCol"></score-by-Subject>  <!-- subject 1 to 10 -->
              <score-by-Subject :dataRow="scoreData[1]" :dataDisable="apCon[1]" :endCol="eCol"></score-by-Subject>
              <score-by-Subject :dataRow="scoreData[2]" :dataDisable="apCon[2]" :endCol="eCol"></score-by-Subject>
              <score-by-Subject :dataRow="scoreData[3]" :dataDisable="apCon[3]" :endCol="eCol"></score-by-Subject>
              <score-by-Subject :dataRow="scoreData[4]" :dataDisable="apCon[4]" :endCol="eCol"></score-by-Subject>
              <score-by-Subject :dataRow="scoreData[5]" :dataDisable="apCon[5]" :endCol="eCol"></score-by-Subject>
              <score-by-Subject :dataRow="scoreData[6]" :dataDisable="apCon[6]" :endCol="eCol"></score-by-Subject>
              <score-by-Subject :dataRow="scoreData[7]" :dataDisable="apCon[7]" :endCol="eCol"></score-by-Subject>
              <score-by-Subject :dataRow="scoreData[8]" :dataDisable="apCon[8]" :endCol="eCol"></score-by-Subject>
              <score-by-Subject :dataRow="scoreData[9]" :dataDisable="apCon[9]" :endCol="eCol"></score-by-Subject>               </v-layout>
          </v-slide-y-transition>
        </v-container>
      </div>
      <div>
        <v-container>        
        </v-container> 
      </div>
    </div>
  </div>
</template>

<script>

import ScoreBySubject from './ScorebySubject.vue'
import apCon from '@/utils/appConfig'

export default {
  name: 'Grade10',
  props: ['scoreData'],
  components: {
    'scoreBySubject': ScoreBySubject
  },
  data () {
    return {
      apCon: apCon.qemisSec10Disable,
      eCol: 2
    }
  }
}
</script>

<style scoped>
  .tContent {
    display: flex;
    flex-direction: column;
    width: 1300px;   
  }
  .fRow {
    display: flex;
    align-content: flex-start;
    padding-top: 0px;
    padding-right: 0px;
    padding-bottom: 0px;
    padding-left: 0px;
  }
  .sRow {
    display: flex;
  }
  .sTtile {
    width: 100px;
    height: 60px;
    text-align: center;
    font-weight: bold;
    background-color: #f8f8f8;
  }
  .gender {
    width: 100px;
    text-align: center;
    background-color: #f8f8f8;
    font-weight: bold;
  }
  .colHeader {
    font-size: 12px;
    width: 50px;
    text-align: center;
    background-color: #f8f8f8;
    font-weight: bold;
  }
  .colTotal {
    text-align: center;
    width: 60px;
    font-weight: bold;
  }
  .cont {
    padding-top: 0px;
    padding-right: 0px;
    padding-bottom: 0px;
    padding-left: 0px;
  }
  .contD {
    padding-top: 2px;
    padding-right: 0px;
    padding-bottom: 0px;
    padding-left: 2px;
  }
  table, th, td {
    border: 1px solid black;
    border-collapse: collapse;
  }
  th, td {
    text-align: left;    
  }
</style>